import { render, staticRenderFns } from "./select_inventory.vue?vue&type=template&id=ed1aef60&scoped=true&"
import script from "./select_inventory.vue?vue&type=script&lang=js&"
export * from "./select_inventory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed1aef60",
  null
  
)

export default component.exports